import { Location } from '@/utils/types';
import { IconName } from '@pathccm/rula-ui/icon';
import Text from '@/components/Text';
import { WithIcon } from '@/components/appointments/WithIcon';

export const SessionType = ({ location }: { location: Location }) => {
  const config: Record<Location, { icon: IconName; copy: string }> = {
    telemedicine: {
      icon: 'Video',
      copy: 'Video session',
    },
    in_person: {
      icon: 'Couch',
      copy: 'In-person session',
    },
  };
  return (
    <WithIcon icon={config[location].icon}>
      <Text.P>{config[location].copy}</Text.P>
    </WithIcon>
  );
};
